"use strict";
const { errors } = require('../constants');
const { expressionSchema } = require('./conditionSteps/expressionSchema');
const { sendSmsSchema, sendEmailSchema, sendWebformSchema, } = require('./taskSteps/sendMessageSchema');
const { timeSchema } = require('./conditionSteps/timeSchema');
const { smsResponseCaptureSchema, webformResponseCaptureSchema, } = require('./conditionSteps/responseCaptureSchema');
const { createValidator } = require('./utils/createValidator');
const { validateConditionStep, validateStartStep, validateTaskStep, } = require('./workflowSchema');
module.exports = {
    condition: validateConditionStep,
    start: validateStartStep,
    task: validateTaskStep,
    // These are here because there are some parts of
    // workflow-studio-ui that are directly using them. (ie not step validation)
    time: createValidator(timeSchema, errors.time),
    'send-sms': createValidator(sendSmsSchema, errors.embeddedMessage),
    'send-email': createValidator(sendEmailSchema, errors.embeddedMessage),
    'send-webform': createValidator(sendWebformSchema, errors.embeddedMessage),
    expression: createValidator(expressionSchema, errors.expression),
    'on-sms-reply': createValidator(smsResponseCaptureSchema, errors.responseCapture),
    'on-sms-no-reply': createValidator(smsResponseCaptureSchema, errors.responseCapture),
    'on-webform-reply': createValidator(webformResponseCaptureSchema, errors.responseCapture),
    'on-webform-no-reply': createValidator(webformResponseCaptureSchema, errors.responseCapture),
};
//# sourceMappingURL=index.js.map